import { getPromos } from '@bonanza-social/promos';
import { statusChangedLegacy } from '@bonanza-social/status';
import { startListening } from '@bonanza-social/toolkit/state';

startListening({
  actionCreator: statusChangedLegacy,
  effect: (_, { dispatch }) => {
    dispatch(getPromos());
  },
});
